import App from './handlers/App';
import Home from './handlers/Home';
import JobDetails from './handlers/JobDetails';
import PageNotFound from 'src/components/PageNotFound/PageNotFound';
import Search from 'src/components/Search/Search';
import SearchResults from './handlers/SearchResults';

import { routes } from '@seek/seek-jobs-seo';

import {
  jobDetailsPageRegex,
  searchResultsPageRegex,
  homePageRegex,
  expiredJobPageRegex
} from 'src/modules/routes-regexp';

const route = (regex, component) => {
  return routes
    .filter(path => regex.test(path))
    .map(path => ({
      path,
      exact: true,
      component
    }));
};

const withSearchBar = (regex, component, options = {}) => {
  return routes
    .filter(path => regex.test(path))
    .map(path => ({
      path,
      component: Search,
      key: 'SEARCH', // use key prop to prevent remounting component when transition was made from route with the same component and same key prop
      routes: [{ component }],
      ...options
    }));
};

const reactRoutes = [
  {
    path: '/',
    component: App,
    routes: [
      ...route(jobDetailsPageRegex, JobDetails),
      ...route(expiredJobPageRegex, JobDetails),

      ...withSearchBar(homePageRegex, Home, { exact: true }),
      ...withSearchBar(searchResultsPageRegex, SearchResults),

      { path: '/*', component: PageNotFound }
    ]
  }
];

export default reactRoutes;
